import { GET_EVENT, SET_EVENTS } from '../types/events';

import {
  deleteEventService,
  getEvent,
  getEvents,
  inviteForEventService,
  joinEventService,
  leaveEventService,
  putEvent as putEventService,
  removeInviteForEventService,
} from '../services/eventsService';

import { CLEAR_ERRORS, SET_ERRORS } from '../types/ui';

export const getAllEvents = () => async (dispatch) => {
  try {
    const allEvents = await getEvents();
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_EVENTS, payload: allEvents });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response.data.message,
    });
  }
};

export const createNewEvent = (data) => putEventService(data);

export const getOneEvent = (eventId) => async (dispatch) => {
  try {
    const eventFromDB = await getEvent(eventId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: GET_EVENT, payload: eventFromDB });
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const joinEvent = (eventId, user) => joinEventService(eventId, user);

export const leaveEvent = (eventId, user) => leaveEventService(eventId, user);

export const deleteEvent = async (eventId) => await deleteEventService(eventId);

export const inviteForEvent = (eventId, userId) => async (dispatch) => {
  try {
    await inviteForEventService(eventId, userId);
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};

export const removeEventInvite = (eventId, userId) => async (dispatch) => {
  try {
    await removeInviteForEventService(eventId, userId);
  } catch (error) {
    dispatch({
      type: SET_ERRORS,
      payload: error.response,
    });
  }
};
